import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bb-footer" data-testid="footer">
      <div className="w-[90%] max-w-[1200px] mx-auto flex flex-col items-center text-center gap-5">
        <Link to="/" className="no-underline">
          <div className="w-[60px] h-[60px] rounded-lg overflow-hidden flex items-center justify-center">
            <img src="/bb-logo.jpeg" alt="BuildBotics" className="w-full h-full object-contain" />
          </div>
        </Link>
        <p className="text-[#94a3b8] text-sm">
          &copy; {new Date().getFullYear()} BuildBotics.in Platform. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
